import * as React from 'react';

import { useIsomorphicLayoutEffect } from '@/use-isomorphic-layout-effect';

export const useEvent = <Args extends unknown[], R>(callback?: (...args: Args) => R): ((...args: Args) => R) => {
	const callbackRef = React.useRef(callback);

	useIsomorphicLayoutEffect(() => {
		callbackRef.current = callback;
	}, [callback]);

	return React.useCallback((...args: Args) => {
		return callbackRef.current?.(...args);
	}, []) as (...args: Args) => R;
};
